import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, forkJoin, map, Observable, of } from 'rxjs';

import { HESTIA_INTERCEPTOR_SKIP_HEADER } from '@hestia/ngx-user';

import { environment } from '../../environments/environment';
import {
  CHILD_EXAMPLE_QNRS,
  DawbaRelationType,
  ISetupCarePlanSetPayload,
  PARENT_EXAMPLE_QNRS,
  TEACHER_EXAMPLE_QNRS,
} from '../models/models';

@Injectable({ providedIn: 'root' })
export class DawbaDevAdminService {
  fhirUserEndpoint = `${environment.apiUrl}@fhir-user`;
  createDawbaUserEndpoint = `${environment.apiUrl}@setup-careplan-set`;
  clikCounter =0;
  constructor(private httpClient: HttpClient) {}

  createRequestHeaders = () =>
    new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set(HESTIA_INTERCEPTOR_SKIP_HEADER, 'true')
      .append(
        'Authorization',
        'Basic ' +
          btoa(
            `${environment.backendAdminUser}:${environment.backendAdminPassword}`
          )
      );

  checkIfTestUsersExists(): Observable<{
    patient: boolean;
    parent: boolean;
    teacher: boolean;
  }> {
    // We only care about patient in this check
    const userNames = [
      environment.testPatientUserName,
      environment.testParentUserName,
      environment.testTeacherUserName,
    ];
    return forkJoin(
      userNames.map((userName) =>
        this.httpClient
          .get(`${this.fhirUserEndpoint}/${userName}`, {
            headers: this.createRequestHeaders(),
          })
          .pipe(
            map((result) => {
              console.log(result);
              return !!result;
            }),
            catchError((_error) => of(false))
          )
      )
    ).pipe(
      map(([patient, parent, teacher]) => ({
        patient,
        parent,
        teacher,
      }))
    );
  }

  createTestUser() {
    const payload: ISetupCarePlanSetPayload = {
      /* eslint-disable @typescript-eslint/naming-convention */
      dawba_event_uuid: '11c2148d-2c65-4a09-910e-f5ba18883aew',
      organization: {
        uuid: '32c3148d-2c65-4a09-910e-f5ba18883afe',
        name: 'Test hospital',
      },
      patient: {
        uuid: 'aa76255e-821e-4673-9242-e88bde23c4c1',
        cpr: '0404030001',
        gender: 'male',
        birth_date: '1987-10-12',
        language: 'dan',
        full_name: 'Mikkel Kramme Abildtoft',
        user_name: environment.testPatientUserName,
        password: environment.testPatientPassword,
        due_date: '2022-04-10',
        available_from_date: '2022-03-30',
        questionnaires: CHILD_EXAMPLE_QNRS,
      },
      related_persons: [
        {
          uuid: environment.testParentUuid,
          cpr: null,  // Provide null if we don't know CPR
          language: 'dan',
          full_name: 'Ole Kramme Abildtoft',
          user_name: environment.testParentUserName,
          password: environment.testParentPassword,
          due_date: '2022-04-10',
          available_from_date: '2022-03-30',
          relationship: DawbaRelationType.FamilyOrCareTaker,
          questionnaires: PARENT_EXAMPLE_QNRS,
        },
        {
          uuid: environment.testTeacherUuid,
          cpr: null,  // Provide null if we don't know CPR
          language: 'dan',
          full_name: 'Jytte Jensen',
          user_name: environment.testTeacherUserName,
          password: environment.testTeacherPassword,
          due_date: '2022-04-10',
          available_from_date: '2022-03-30',
          relationship: DawbaRelationType.EducationalStaff,
          questionnaires: TEACHER_EXAMPLE_QNRS,
        },
      ],
      /* eslint-enable @typescript-eslint/naming-convention */
    };
    return this.httpClient.post(this.createDawbaUserEndpoint, payload, {
      headers: this.createRequestHeaders(),
    });
  }

  editLanguage(language) {
    this.clikCounter=this.clikCounter+1
    console.log(this.clikCounter);
    if (this.clikCounter==3){
      this.clikCounter=0;
      return this.httpClient.post(`${environment.apiUrl}/@edit_user_language`, {'language':language});
    }
  }

  deleteTestUsers(): Observable<unknown> {
    const userNames = [
      environment.testPatientUserName,
      environment.testParentUserName,
      environment.testTeacherUserName,
    ];
    return forkJoin(
      userNames.map((userName) =>
        this.httpClient.delete(`${this.fhirUserEndpoint}/${userName}`, {
          headers: this.createRequestHeaders(),
        })
      )
    );
  }
}
